<template>
  <v-container fluid>
    <v-card>
      <v-app-bar color="primary" flat dark dense>
        <v-toolbar-title>Produtos</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          fab
          small
          color="primary lighten-4"
          class="ml-2"
          v-if="user.tipo !== 'master'"
          @click="$refs.dialogoImpressaoListagem.abrir()"
        >
          <v-icon>print</v-icon>
        </v-btn>
        <v-btn
          fab
          small
          color="primary lighten-4"
          @click="tooglePesquisa"
          class="ml-2"
        >
          <v-icon>search</v-icon>
        </v-btn>
        <v-btn
          depressed
          color="primary lighten-4"
          @click="$refs.cadastroTamanhos.abrir()"
          class="hidden-xs-only ml-2"
          v-if="user.tipo == 'fornecedor'"
          >Tamanhos</v-btn
        >
        <v-btn
          fab
          small
          color="primary lighten-4"
          @click="$refs.cadastroTamanhos.abrir()"
          class="hidden-sm-and-up ml-2"
          v-if="user.tipo == 'fornecedor'"
        >
          <v-icon>format_size</v-icon>
        </v-btn>
        <v-btn
          depressed
          color="primary lighten-4"
          @click="$refs.cadastroCores.abrir()"
          class="hidden-xs-only ml-2"
          v-if="user.tipo == 'fornecedor'"
          >Cores</v-btn
        >
        <v-btn
          fab
          small
          color="primary lighten-4"
          @click="$refs.cadastroCores.abrir()"
          class="hidden-sm-and-up ml-2"
          v-if="user.tipo == 'fornecedor'"
        >
          <v-icon>invert_colors</v-icon>
        </v-btn>
        <v-btn
          depressed
          color="primary lighten-4"
          @click="$router.push('produtos/adicionar')"
          class="hidden-xs-only ml-2"
          v-if="user.tipo == 'fornecedor'"
          >Adicionar</v-btn
        >
        <v-btn
          fab
          small
          color="primary lighten-4"
          @click="$router.push('produtos/adicionar')"
          class="hidden-sm-and-up ml-2"
          v-if="user.tipo == 'fornecedor'"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-app-bar>
      <v-expand-transition>
        <v-row dense v-show="exibirPesquisa" class="pa-2">
          <v-col cols="12" pa-2>
            <v-text-field
              ref="pesquisa"
              label="Pesquisa"
              v-model="pesquisa"
              prepend-inner-icon="search"
              solo
              clearable
              single-line
              hide-details
              placeholder="Pesquisa"
              background-color="grey lighten-2"
              @click:clear="tooglePesquisa"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-expand-transition>

      <v-divider></v-divider>

      <cores ref="cadastroCores" v-if="user.tipo == 'fornecedor'"></cores>
      <tamanhos
        ref="cadastroTamanhos"
        v-if="user.tipo == 'fornecedor'"
      ></tamanhos>

      <v-data-table
        :search="pesquisa"
        :headers="headers"
        :items="produtos"
        :loading="loading"
        no-data-text="Sem registros"
        no-results-text="Sem registros"
        loading-text="Carregando dados..."
        :items-per-page="30"
        :footer-props="{
          itemsPerPageOptions: [10, 30, 50, { text: 'Todos', value: -1 }],
          itemsPerPageText: '',
        }"
      >
        <template v-slot:top v-if="user.tipo == 'fornecedor'">
          <v-row
            dense
            style="display: flex; justify-content: flex-end"
            class="px-2 py-0"
          >
            <v-col
              cols="12"
              sm="4"
              class="px-2 pt-2 pb-3"
              style="display: flex; justify-content: flex-end"
            >
              <v-radio-group
                v-model="filtro.ativos"
                @change="filtrar"
                row
                hide-details
              >
                <v-radio label="Ativos" value="1"></v-radio>
                <v-radio label="Desativados" value="0"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12" sm="4" class="px-2 pt-2 pb-3">
              <v-select
                :items="statusLista"
                label="Status"
                v-model="filtro.status"
                hide-details
                @input="filtrar"
              ></v-select>
            </v-col>
          </v-row>
          <v-divider></v-divider>
        </template>

        <template v-slot:item.status="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                label
                small
                @click="abrirDialogoDetalhes(item)"
                v-bind="attrs"
                v-on="on"
                v-if="item.status == 0"
                style="min-width: 120px;"
                class="justify-center"
                >Em Homologação</v-chip
              >
              <v-chip
                label
                color="success"
                small
                @click="abrirDialogoDetalhes(item)"
                v-bind="attrs"
                v-on="on"
                v-if="item.status == 1"
                style="min-width: 120px;"
                class="justify-center"
                >Homologado</v-chip
              >
              <v-chip
                label
                color="error"
                small
                @click="abrirDialogoDetalhes(item)"
                v-bind="attrs"
                v-on="on"
                v-if="item.status == 2"
                style="min-width: 120px;"
                class="justify-center"
                >Reprovado</v-chip
              >
              <v-chip
                label
                color="orange"
                small
                v-if="item.status == 3"
                @click="abrirDialogoRenovarProduto(item)"
                style="min-width: 120px;"
                class="justify-center"
                >Vencido</v-chip
              >
            </template>
            <span>Clique para detalhes</span>
          </v-tooltip>
        </template>
        <template v-slot:item.valor="{ item }">{{
          item.valor | valorBR
        }}</template>
        <template v-slot:item.ativo="{ item }">
          <v-icon v-if="item.ativo == 0" @click="ativar(item)"
            >mdi-checkbox-blank-outline</v-icon
          >
          <v-icon v-else @click="abrirDialogoDesativar(item)"
            >mdi-checkbox-marked</v-icon
          >
        </template>
        <template v-slot:item.opcoes="{ item }">
          <div style="display: flex; justify-content: center;">
            <v-btn
              icon
              @click="$router.push('produtos/' + item.id + '/galeria')"
              v-if="$auth.user.tipo === 'fornecedor'"
            >
              <v-icon>collections</v-icon>
            </v-btn>
            <v-menu bottom left v-if="user.tipo == 'fornecedor'">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>

              <v-list dense>
                <v-list-item
                  @click="$router.push('produtos/' + item.id + '/editar')"
                >
                  <v-list-item-title>
                    <v-icon class="pr-4">edit</v-icon>Editar
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="abrirDialogoExcluir(item)">
                  <v-list-item-title>
                    <v-icon class="pr-4">delete</v-icon>Excluir
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-btn
              icon
              class="mx-2"
              v-if="user.tipo == 'master'"
              @click="abrirDialogoInfoProduto(item)"
            >
              <v-icon>mdi-text-box-check-outline</v-icon>
            </v-btn>
          </div>
        </template>
        <template v-slot:footer.page-text="produtos"
          >Exibindo {{ produtos.pageStart }} - {{ produtos.pageStop }} de
          {{ produtos.itemsLength }}</template
        >
      </v-data-table>
    </v-card>

    <as-dialogo
      ref="dialogoExcluir"
      title="Excluir produto"
      max-width="440px"
      hideCloseButton
    >
      <v-label>Tem certeza que deseja excluir esse produto?</v-label>
      <div class="pt-8" style="display: flex; justify-content: flex-end;">
        <v-btn depressed class="mr-4" @click="$refs.dialogoExcluir.fechar()"
          >Cancelar</v-btn
        >
        <v-btn
          depressed
          color="error"
          @click="excluir"
          :disabled="excluindo"
          :loading="excluindo"
          >Excluir</v-btn
        >
      </div>
    </as-dialogo>

    <as-dialogo
      ref="dialogoImpressaoListagem"
      title="Listagem de Produtos"
      max-width="440px"
      hideCloseButton
    >
      <v-label>Deseja imprimir a listagem de produtos?</v-label>
      <div class="pt-8" style="display: flex; justify-content: flex-end;">
        <v-btn
          depressed
          class="mr-4"
          @click="$refs.dialogoImpressaoListagem.fechar()"
          >Cancelar</v-btn
        >
        <v-btn
          depressed
          color="primary"
          @click="imprimirListagem"
          :disabled="imprimindo"
          :loading="imprimindo"
          >Imprimir</v-btn
        >
      </div>
    </as-dialogo>

    <as-dialogo
      ref="dialogoDetalhes"
      title="Homologação do Produto"
      max-width="600px"
      hideCloseButton
    >
      <v-row v-show="loading" v-if="loading">
        <v-col
          class="my-2 pa-0"
          style="display: flex; align-items: center; justify-content: center; text-align: center"
        >
          <v-progress-circular
            size="64"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-col>
      </v-row>
      <template v-else>
        <v-row dense v-if="produto.status == 2">
          <v-col
            cols="2"
            class="justify-center align-center"
            style="display: flex; transform: scale(1.5)"
          >
            <v-icon x-large color="error">mdi-close-circle-outline</v-icon>
          </v-col>
          <v-col cols="10">
            <v-label
              >Seu produto ainda não está sendo exibido nas buscas da loja
              porque alguns problemas foram encontrados.</v-label
            >
          </v-col>
        </v-row>
        <v-row
          dense
          v-for="(detalhe, index) in produto_detalhes"
          :key="index"
          class="justify-center align-center"
        >
          <v-col
            cols="2"
            class="justify-center align-center"
            style="display: flex"
          >
            <v-icon x-large v-if="produto.status == 0">schedule</v-icon>
            <v-icon x-large v-if="produto.status == 1" color="success"
              >check</v-icon
            >
            <!-- <v-icon x-large v-if="produto.status == 2" color="error">mdi-close-circle-outline</v-icon> -->
          </v-col>
          <v-col cols="10" class="justify-center align-center">
            <span v-if="produto.status == 2" style="color: red">{{
              detalhe
            }}</span>
            <v-label v-else>{{ detalhe }}</v-label>
          </v-col>
        </v-row>
        <v-row
          v-if="produto.status == 2"
          dense
          class="justify-center align-center"
        >
          <v-col
            cols="2"
            class="justify-center align-center"
            style="display: flex"
          ></v-col>
          <v-col cols="10" class="justify-center align-center">
            <small
              >Corrija o mais rápido posível para que ele possa ser exibido na
              loja</small
            >
          </v-col>
        </v-row>
      </template>
      <div class="pt-4" style="display: flex; justify-content: flex-end;">
        <v-btn
          v-if="produto.status == 2"
          depressed
          color="primary lighten-3"
          class="mr-4"
          @click="$router.push('produtos/' + produto.id + '/editar')"
          >Editar Produto</v-btn
        >
        <v-btn
          v-if="produto.status == 2"
          depressed
          color="primary lighten-3"
          @click="$router.push('produtos/' + produto.id + '/galeria')"
          >Galeria</v-btn
        >
        <v-spacer />
        <v-btn depressed color="primary" @click="fecharDialogoDetalhes"
          >Fechar</v-btn
        >
      </div>
    </as-dialogo>

    <as-dialogo
      ref="dialogoReprovar"
      title="Reprovar Produto"
      max-width="1000px"
      hideCloseButton
      @onFechar="limparErros"
    >
      <v-container class="pa-0">
        <v-row>
          <v-col cols="12" class="pt-0">
            <h3 class="mb-2">Selecione os motivos</h3>
            <v-card class="pa-2">
              <v-chip
                class="ma-2"
                v-for="(erro, index) in possiveis_erros"
                :key="index"
                link
                @click="adicionarErro(erro)"
                >{{ erro.nome }}</v-chip
              >
              <v-btn
                fab
                depressed
                x-small
                color="primary"
                dark
                class="mx-2"
                @click="$refs.dialogoNovoErro.abrir()"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="erros_produto.length > 0">
          <v-col cols="12">
            <h3 class="mb-2">Motivos</h3>
            <v-card>
              <v-data-table
                :headers="headers_erros"
                :items="erros_produto"
                hide-default-footer
                hide-default-header
              >
                <template v-slot:item.opcoes="{ item }">
                  <v-btn icon @click="removerErro(item)">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <div class="pt-1" style="display: flex; justify-content: flex-end;">
        <v-btn depressed class="mr-4" @click="$refs.dialogoReprovar.fechar()"
          >Cancelar</v-btn
        >
        <v-btn
          depressed
          color="error"
          :disabled="homologando || erros_produto.length == 0"
          :loading="homologando"
          @click="homologarProduto(2)"
          >Reprovar</v-btn
        >
      </div>
    </as-dialogo>

    <as-dialogo
      ref="dialogoNovoErro"
      title="Descrever Motivo"
      max-width="800px"
    >
      <v-text-field
        label="Motivo"
        ref="erro_avulso"
        v-model="erro_avulso"
        autofocus
        @keypress.native.enter="adicionarErroAvulso"
        @blur="erro_avulso.length == 0 ? (erro_avulso_mostrar = false) : ''"
        hide-details
      />
      <div class="pt-4" style="display: flex; justify-content: flex-end;">
        <v-btn depressed class="mr-4" @click="$refs.dialogoNovoErro.fechar()"
          >Cancelar</v-btn
        >
        <v-btn
          depressed
          color="primary"
          @click="adicionarErroAvulso"
          :disabled="!erro_avulso"
          >Confirmar</v-btn
        >
      </div>
    </as-dialogo>

    <as-dialogo
      ref="dialogoRenovarProduto"
      title="Produto Vencido"
      max-width="440px"
      hideCloseButton
    >
      <v-label>Ainda vende este produto?</v-label>
      <div class="pt-4" style="display: flex; justify-content: flex-end;">
        <v-btn depressed class="mr-4" @click="naoRenovarProdutoVencido"
          >Não</v-btn
        >
        <v-btn depressed color="primary" @click="renovarProdutoVencido"
          >Sim</v-btn
        >
      </div>
    </as-dialogo>

    <as-dialogo
      ref="dialogoDesativar"
      title="Desativar produto"
      max-width="440px"
      hideCloseButton
    >
      <v-label>Tem certeza que deseja desativar esse produto?</v-label>
      <p class="pt-2 mb-0" style="color: red">
        Produtos desativados não aparecem nas buscas realizadas na loja e não
        podem ser usados em pedidos na rodada de negócio!
      </p>
      <div class="pt-4" style="display: flex; justify-content: flex-end;">
        <v-btn depressed class="mr-4" @click="$refs.dialogoDesativar.fechar()"
          >Cancelar</v-btn
        >
        <v-btn
          depressed
          color="error"
          @click="desativar"
          :disabled="loading"
          :loading="loading"
          >Desativar</v-btn
        >
      </div>
    </as-dialogo>

    <detalhe-produto
      :produto="produto_detalhe"
      ref="detalheProduto"
      @aprovar="homologarProduto(1)"
      @reprovar="abrirDialogoReprovarProduto"
    />
  </v-container>
</template>

<script>
import Cores from "./Cores";
import Tamanhos from "./Tamanhos";
import DetalheProduto from "@/views/loja/DetalheProduto.vue";

import Services from "../../services/services.js";
import ServiceProdutos from "../../services/produtos.js";
import ServiceImpressoes from "@/services/impressoes.js";

export default {
  name: "ProdutosLista",
  components: {
    Cores,
    Tamanhos,
    DetalheProduto,
  },
  data() {
    return {
      user: {},
      exibirPesquisa: false,
      pesquisa: "",
      loading: false,
      headers: [
        { text: "Código", value: "codigo", width: "10%" },
        { text: "Descrição", value: "descricao", width: "55%" },
        { text: "Valor", value: "valor", width: "10%" },
        { text: "Status", value: "status", width: "10%", align: "left" },
      ],
      filtro: {
        filtro: "1",
        status: "Todos",
        ativos: "1",
      },
      statusLista: [
        "Todos",
        "Em homologação",
        "Homologados",
        "Reprovados",
        "Vencidos",
      ],
      produtos: [],
      excluindo: false,
      produto: {},
      imprimindo: false,
      produto_detalhes: [],
      carregando_midia: false,
      galeria: {
        fotos: [],
        video: "",
      },
      tab_atual: "fotos",
      homologando: false,
      erros_homologacao: [],
      erros_produto: [],
      headers_erros: [
        { text: "Descrição", value: "descricao", width: "100%" },
        {
          text: "Remover",
          value: "opcoes",
          width: "40px",
          sortable: false,
          align: "right",
        },
      ],
      erro_avulso_mostrar: false,
      erro_avulso: "",
      produto_detalhe: {},
    };
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.filtro.status =
      this.$auth.user.tipo === "fornecedor" ? "Todos" : "Em homologação";

    if (this.$auth.user.tipo === "fornecedor") {
      this.$route.query;
      this.filtro = {
        filtro: this.$route.query.filtro || "1",
        status: this.$route.query.status || "Todos",
        ativos: this.$route.query.ativo || "1",
      };
      window.location.replace(
        `${window.location.origin}/#/produtos?filtro=${this.filtro.filtro}&status=${this.filtro.status}&ativo=${this.filtro.ativos}`
      );
    }

    if (this.$auth.user.tipo === "fornecedor") {
      this.headers.push({
        text: "Ativo",
        value: "ativo",
        width: "64px",
        sortable: false,
      });
      this.headers.push({
        text: "",
        value: "opcoes",
        width: "100px",
        align: "center",
        sortable: false,
      });
    }
    if (this.$auth.user.tipo === "master") {
      this.headers = [
        { text: "Código", value: "codigo", width: "10%" },
        { text: "Descrição", value: "descricao", width: "35%" },
        { text: "Fornecedor", value: "fornecedor_nome", width: "20%" },
        { text: "Valor", value: "valor", width: "10%" },
        { text: "Status", value: "status", width: "10%", align: "left" },
      ];
      this.headers.push({
        text: "Homologar",
        value: "opcoes",
        width: "100px",
        align: "center",
        sortable: false,
      });
    }
    this.filtrar();
  },
  methods: {
    tooglePesquisa() {
      this.exibirPesquisa = !this.exibirPesquisa;
      if (this.exibirPesquisa) {
        setTimeout(() => {
          this.$refs.pesquisa.focus();
        }, 0);
      }
    },
    async listar() {
      try {
        this.loading = true;
        let produtos_response = await ServiceProdutos.listar();
        this.produtos = produtos_response.data.produtos;
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao listar produtos");
      } finally {
        this.loading = false;
      }
    },
    async filtrar() {
      try {
        this.loading = true;
        let filtro = await ServiceProdutos.filtrar({
          filtro: this.filtro.filtro,
          status: this.filtro.status,
          ativo: this.filtro.ativos,
        });

        window.location.replace(
          `${window.location.origin}/#/produtos?filtro=${this.filtro.filtro}&status=${this.filtro.status}&ativo=${this.filtro.ativos}`
        );

        this.produtos = filtro.data.produtos;
      } catch (error) {
        this.$eventbus.erro("Houve um erro ao filtrar os produtos");
      } finally {
        this.loading = false;
      }
    },
    async abrirDialogoReprovarProduto() {
      if (this.erros_homologacao.length == 0) {
        let erros_response = await ServiceProdutos.listarPossiveisErros();
        this.erros_homologacao = erros_response.data.erros_homologacao;
      }
      this.$refs.dialogoReprovar.abrir();
    },
    abrirDialogoExcluir(produto) {
      this.produto = produto;
      this.$refs.dialogoExcluir.abrir();
    },
    async excluir() {
      try {
        this.excluindo = true;
        let response = await ServiceProdutos.excluir(this.produto.id);

        if (response.data.status == 1) {
          this.$eventbus.notificar(response.data.msg);
          this.produto = {};
          this.listar();
        } else if (response.data.status == 2) {
          this.$eventbus.erro(response.data.msg);
        }
      } catch (error) {
        this.$eventbus.erro("Erro ao excluir produto", error);
      } finally {
        this.$refs.dialogoExcluir.fechar();
        this.excluindo = false;
      }
    },
    async imprimirListagem() {
      try {
        this.imprimindo = true;
        let impressao = JSON.parse(localStorage.getItem("impressao_remota"))
          ? "remota"
          : "local";
        if (impressao == "local") {
          this.$store.commit("showImprimirPdf", true);
        }
        let pdf = await ServiceImpressoes.listarProdutos({
          impressao,
          rodada_id: this.$store.state.rodada.id,
        });
        if (impressao == "local") {
          this.$store.commit("setPdfUrl", pdf);
        } else {
          this.$eventbus.notificar(
            "Impressão encaminhada para a Ilha de Impressão com sucesso"
          );
        }
      } catch (error) {
        this.$eventbus.erro("Erro ao imprimir listagem de produtos");
      } finally {
        this.imprimindo = false;
        this.$refs.dialogoImpressaoListagem.fechar();
      }
    },
    async abrirDialogoDetalhes(produto_selecionado) {
      this.produto = this.clone(produto_selecionado);
      if (this.produto.status == 0) {
        this.produto_detalhes = [
          "O seu produto está sendo analisado. Se for aprovado, seu produto já poderá ser encontrado nas buscas da loja.",
        ];
      } else if (this.produto.status == 1) {
        this.produto_detalhes = [
          "Seu produto foi aprovado e já pode ser encontrado nas buscas feitas na loja!",
        ];
      } else {
        this.loading = true;
        try {
          let detalhes = await ServiceProdutos.homologacao(this.produto.id);
          this.produto_detalhes = detalhes.data.homologacao;
          this.loading = false;
        } catch (error) {
          console.log(error);
          this.$eventbus.erro(
            "Erro ao carregar informações da homologação do produto"
          );
        }
      }
      this.$refs.dialogoDetalhes.abrir();
    },
    fecharDialogoDetalhes() {
      this.produto = {};
      this.produto_detalhes = [];
      this.$refs.dialogoDetalhes.fechar();
    },
    async abrirDialogoInfoProduto(produto_selecionado) {
      const { data: dataPro } = await ServiceProdutos.buscarPorId([
        produto_selecionado.id,
      ]);

      this.produto_detalhe = dataPro.produtos[0];

      this.$refs.detalheProduto.abrir();
    },
    fecharDialogoInfoProduto() {
      this.$refs.detalheProduto.fechar();
      this.produto = {};
      this.tab_atual = "fotos";
      this.galeria = {
        fotos: [],
        video: "",
      };
    },
    async homologarProduto(status_produto) {
      this.homologando = true;
      try {
        await ServiceProdutos.homologar(
          this.produto_detalhe.id,
          status_produto,
          this.erros_produto
        );

        const idx = this.produtos.findIndex(
          (item) => item.id === this.produto_detalhe.id
        );

        this.produtos.splice(idx, 1);

        this.$refs.dialogoReprovar.fechar();
        this.fecharDialogoInfoProduto();
        let texto_notificacao = status_produto == 1 ? "Aprovado" : "Reprovado";
        this.$eventbus.notificar(`Produto ${texto_notificacao} com sucesso`);
      } catch (error) {
        this.$eventbus.erro("Erro ao homologar produto");
      } finally {
        this.homologando = false;
      }
    },
    abrirDialogoRenovarProduto(produto_selecionado) {
      this.produto = this.clone(produto_selecionado);
      this.$refs.dialogoRenovarProduto.abrir();
    },
    async renovarProdutoVencido() {
      try {
        this.$refs.dialogoRenovarProduto.fechar();
        let response = await ServiceProdutos.renovarProdutoVencido(
          this.produto.id,
          1
        );
        let indice = this.produtos.findIndex(
          (produto) => produto.id === this.produto.id
        );
        this.$nextTick(() => {
          this.produtos = [];
          this.listar();
        });
      } catch (error) {
        //
      } finally {
        //
      }
    },
    async naoRenovarProdutoVencido() {
      try {
        this.$refs.dialogoRenovarProduto.fechar();
        let response = await ServiceProdutos.renovarProdutoVencido(
          this.produto.id,
          2
        );
        let indice = this.produtos.findIndex(
          (produto) => produto.id === this.produto.id
        );
        this.produtos.splice(indice, 1);
      } catch (error) {
        //
      } finally {
        //
      }
    },
    adicionarErro(erro) {
      this.erros_produto.unshift(erro);
    },
    removerErro(erro) {
      let index = this.erros_produto.indexOf(erro);
      this.erros_produto.splice(index, 1);
    },
    limparErros() {
      this.erros_produto = [];
    },
    adicionarErroAvulso() {
      if (this.erro_avulso.length > 0) {
        let erro_avulso_objeto = {
          id: null,
          nome: "",
          descricao: this.erro_avulso,
        };
        this.erros_produto.unshift(erro_avulso_objeto);
      }
      this.erro_avulso = "";
      this.$refs.dialogoNovoErro.fechar();
    },
    async ativar(produto_selecionado) {
      this.produto = this.clone(produto_selecionado);
      try {
        this.loading = true;
        let response = await ServiceProdutos.ativar(this.produto.id);
        this.$eventbus.notificar(response.data.msg);
        this.listar();
      } catch (error) {
        this.$eventbus.erro(error.response.data.msg);
      } finally {
        this.loading = false;
      }
    },
    abrirDialogoDesativar(produto_selecionado) {
      this.produto = this.clone(produto_selecionado);
      this.$refs.dialogoDesativar.abrir();
    },
    async desativar() {
      try {
        this.loading = true;
        let response = await ServiceProdutos.desativar(this.produto.id);
        this.$eventbus.notificar(response.data.msg);
        this.listar();
        this.$refs.dialogoDesativar.fechar();
      } catch (error) {
        this.$eventbus.erro(error.response.data.msg);
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    possiveis_erros() {
      let possiveis_erros = this.erros_homologacao.filter((erro) => {
        if (this.erros_produto.length == 0) {
          return erro;
        } else {
          let index = this.erros_produto.indexOf(erro);
          if (index == -1) {
            return erro;
          }
        }
      });

      return possiveis_erros;
    },
  },
};
</script>

<style></style>
